/*
 *   Copyright (c) 2021 vlinder
 *   All rights reserved.
 *   This software is proprietary of vlinder and can not be distributed / used for any purpose outside of vlinder without explicit written consent from the copyright owner.
 */
import _ from "lodash";
import { createMachine, interpret } from "xstate";
import { waitFor } from "xstate/lib/waitFor";

import { LoggerModule } from "@vlinder-web/logger-module-react";

const is = require("is_js");
const MODULE_NAME = "VappRequestProcessor";
const log = LoggerModule?.getInstance();

export interface VappMachineConfig {
  id: string;
  initial: string;
  predictableActionArguments: true;
  context: any;
  states: any;
  extendContextWith: Function;
}

export class VappRequestProcessor {
  constructor() {}

  protected async startProcessing({
    machineConfig,
    machineType,
  }: {
    machineConfig: any;
    machineType: VappMachineType;
  }) {
    if (is.not.existy(machineConfig)) {
      throw Error(`machineConfig cannot be empty`);
    }
    if (is.not.existy(machineConfig.id)) {
      throw Error(`id cannot be empty`);
    }
    try {
      const machine = createMachine(machineConfig);
      const interpreter = interpret(machine).onTransition((state) => {
        const stateValue = _.isObject(state.value)
          ? JSON.stringify(state.value)
          : state?.value;

        log?.blue(
          MODULE_NAME,
          `[SM]: id:${machineConfig.id} state: ${stateValue}`
        );
      });
      const actor = interpreter.start();
      interpreter.send({ type: "START" });
      const doneState: any = await waitFor(
        actor,
        (state: any) =>
          state.matches("END") ||
          state.matches("ERROR") ||
          state.matches("DOWNSTREAM_EVENTS"),
        {
          timeout: 100000,
        }
      );
      this.checkForError(doneState);
      return doneState?.event?.data;
    } catch (err: any) {
      console.log("error in startProcessing =>", err);
      throw err;
    }
  }
  private checkForError(doneState: any) {
    if (doneState?.value === "ERROR") {
      throw Error(doneState?.event?.data);
    }
  }
}
